<template>
  <div class="image-wrapper text-center">
    <v-img :src="source" @load="handleImageLoaded" :style="styles"></v-img>
  </div>
</template>

<script>

export default {
  name: 'PdfViewer',
  props: {
    source: String,
    rotate: {
      type: Number,
      default: 0
    },
  },
  computed: {
    styles() {
      return {'transform': `rotate(${this.rotate}deg)`}
    }
  },
  methods: {
    handleImageLoaded() {
      this.$emit('loaded', true)
    }
  }
}
</script>

<style scoped>
.image-wrapper {
  min-height: 500px;
  /*height: 500px;*/
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>